'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createApp = exports.createAppFromProps = undefined;

var _Widget = require('../Widget');

var _emit = require('./emit');

var _EventHandler = require('./EventHandler');

var _Storage = require('../Storage');

var _Security = require('../Security');

var _AppEvents = require('./AppEvents');

var _Context = require('../Context');

var _ContextUserEvents = require('./ContextUserEvents');

var _WebAPI = require('../WebAPI');

var _DeskproWindow = require('../DeskproWindow');

var _AppClient = require('./AppClient');

var _AppClient2 = _interopRequireDefault(_AppClient);

var _InstanceProps = require('./InstanceProps');

var _InstanceProps2 = _interopRequireDefault(_InstanceProps);

var _ContextProps = require('./ContextProps');

var _ContextProps2 = _interopRequireDefault(_ContextProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 * @internal
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {AppClient} app
 */
var registerAppEventListeners = function registerAppEventListeners(windowBridge, app) {
  (0, _EventHandler.handleInvokeEvents)(windowBridge, app);

  [_Security.registerEventHandlers, _Storage.registerEventHandlers, _AppEvents.registerEventHandlers, _ContextUserEvents.registerEventHandlers, _Context.registerEventHandlers, _WebAPI.registerEventHandlers, _DeskproWindow.registerEventHandlers].forEach(function (registrar) {
    return registrar(windowBridge, app, _emit.IncomingEventDispatcher, _emit.OutgoingEventDispatcher);
  });

  return app;
};

/**
 * Creates an application using the keys defined on the props object
 *
 * @method
 * @param {WidgetWindowBridge} widgetWindow
 * @param {Object} instanceProps
 * @param {Object} contextProps
 * @return {AppClient}
 */
/**
 * Exports application factories
 *
 * @module Core/createApp
 */

var createAppFromProps = exports.createAppFromProps = function createAppFromProps(_ref) {
  var widgetWindow = _ref.widgetWindow,
      instanceProps = _ref.instanceProps,
      contextProps = _ref.contextProps;

  var appProps = {
    registerEventHandlers: _EventHandler.handleAppEvents.bind(null, widgetWindow),
    incomingDispatcher: _emit.IncomingEventDispatcher,
    outgoingDispatcher: _emit.OutgoingEventDispatcher,
    internalDispatcher: _emit.InternalEventDispatcher,
    instanceProps: new _InstanceProps2.default(instanceProps),
    contextProps: new _ContextProps2.default(contextProps)
  };

  return new _AppClient2.default(appProps);
};

/**
 * @function
 * @param {createAppCallback} cb a callback to be invoked after the app is ready
 */
var createApp = exports.createApp = function createApp(cb) {
  var WidgetWindow = _Widget.WidgetFactories.windowBridgeFromWindow(window);

  WidgetWindow.connect(createAppFromProps).then(registerAppEventListeners.bind(null, WidgetWindow)).then(cb).catch(function (err) {
    cb(err);
  }); // the error scenario needs re-thinking
};

exports.default = createApp;

/**
 * Event emitter function
 *
 * @callback createAppCallback
 * @param {Error|null} error
 */


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/createApp.js
// module id = 233
// module chunks = 0